<guest-layout></guest-layout>

<!-- <admin-layout *ngIf="auth$ | async"></admin-layout> -->